export default __webpack_public_path__ + "static/s1-4d85910d4c0b146667c86411fd8b47d1.png";